import { observable } from 'mobx';
import type { DepartmentResponseArgs } from './department2';
import Department, { convertDepartmentResponseToArgs } from './department2';

export type ChargingDepartmentShareMappingResponseArgs = {
  id: number;
  department_id: number;
  department: DepartmentResponseArgs;
  charging_department_share_id: number;
  weight: number;
};

export type ChargingDepartmentShareMappingArgs = {
  id: number;
  departmentId: number;
  department: Department;
  chargingDepartmentShareId: number;
  weight: number;
};

export const convertChargingDepartmentShareMappingResponseToArgs = (
  response: ChargingDepartmentShareMappingResponseArgs
): ChargingDepartmentShareMappingArgs => {
  return {
    id: response.id,
    departmentId: response.department_id,
    department: new Department(convertDepartmentResponseToArgs(response.department)),
    chargingDepartmentShareId: response.charging_department_share_id,
    weight: response.weight
  };
};

export default class ChargingDepartmentShareMapping {
  @observable id: number;
  @observable departmentId: number;
  @observable department: Department;
  @observable chargingDepartmentShareId: number;
  @observable weight: number;

  constructor(args: ChargingDepartmentShareMappingArgs) {
    this.id = args.id;
    this.departmentId = args.departmentId;
    this.department = args.department;
    this.chargingDepartmentShareId = args.chargingDepartmentShareId;
    this.weight = args.weight;
  }
}
